import { __decorate, __extends } from "tslib";
import { Options } from 'vue-class-component';
import NavPanel from '@/components/common/NavPanel.vue';
import AvalonGTView from '@/utils/libs/BaseView';
import { PageService } from '@/views/copy/taskcenter/import';
import SVGA from 'svgaplayerweb';
import AvalonGTConfig from '@/utils/Config';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.navH = 0;
        _this.statusH = 0;
        // 2022/2/15 14:32 升级的数据
        _this.upgradeList = [
            {
                icon: AvalonGTConfig.Global.H5ImgUrl + 'taoquKnighthood/zengsongliwu@3x.png',
                title: '赠送礼物',
                subTitle: '对方赠送礼物，每收到1钻石增加1魅力值',
            },
            {
                icon: AvalonGTConfig.Global.H5ImgUrl + 'taoquKnighthood/xindong@3x.png',
                title: '心动',
                subTitle: '心动小哥哥/小姐姐可增加财富值',
            },
            {
                icon: AvalonGTConfig.Global.H5ImgUrl + 'taoquKnighthood/sixinliaotian@3x.png',
                title: '私信聊天',
                subTitle: '主动找TA聊天可增加爵位等级',
            },
            {
                icon: AvalonGTConfig.Global.H5ImgUrl + 'taoquKnighthood/yuyintonghua@3x.png',
                title: '语音通话',
                subTitle: '主动拨打语音电话的时间越长，升级越快',
            },
            {
                icon: AvalonGTConfig.Global.H5ImgUrl + 'taoquKnighthood/shipintonghua@3x.png',
                title: '视频通话',
                subTitle: '主动拨打视频通话的时间越长，升级越快',
            },
            {
                icon: AvalonGTConfig.Global.H5ImgUrl + 'taoquKnighthood/yuyinsupei@3x.png',
                title: '语音速配',
                subTitle: '语音速配的通话时间越长，升级越快',
            },
            {
                icon: AvalonGTConfig.Global.H5ImgUrl + 'taoquKnighthood/shipinsupei@3x.png',
                title: '视频速配',
                subTitle: '视频速配的通话时间越长，升级越快',
            },
        ];
        // 2022/2/15 14:58 爵位等级列表
        _this.knighthoodList = [];
        _this.isShowNav = true; // 2022/2/15 16:35 导航是否展示白色
        _this.isFix = false; // 2022/2/15 16:35 人员是否吸附
        _this.nobilityInfo = {}; // 2022/2/16 16:50 爵位信息
        _this.title = ''; // 2022/2/17 13:55 标题
        _this.loading = false;
        _this.equipment = '';
        return _this;
    }
    View.prototype.created = function () {
        this.navH = this.awlGlobalState.urlInitParams.navH;
        this.statusH = this.awlGlobalState.urlInitParams.statusH;
        this.loading = true;
        // 2022/3/2 15:44 获取设备信息
        this.equipment = this.awlGlobalConfig.isEquipmentEnvironment();
        this.getNobilityInfo();
        window.addEventListener('scroll', this.handleScroll);
    };
    // 2022/2/16 16:34 获取爵位信息
    View.prototype.getNobilityInfo = function () {
        var _this = this;
        PageService.getNobilityInfo({
            targetUserId: this.awlGlobalState.urlInitParams.id,
            os: this.equipment == 'Android' ? '1' : '2',
            osv: this.awlGlobalState.urlInitParams.version,
            channel: this.equipment == 'Android' ? '' : 'apple',
        })
            .then(function (data) {
            _this.loading = false;
            _this.nobilityInfo = data;
            _this.knighthoodList = data.nobilityLevel;
            if (data.avatarFrameSvg) {
                setTimeout(function () {
                    _this.playAni();
                }, 100);
            }
            // this.title = data.isSelf ? '我的爵位' : 'Ta的爵位';
            _this.title = '财富等级';
        })
            .catch(function () {
            _this.loading = false;
        });
    };
    // 2022/5/10 10:57 播放头像框svg
    View.prototype.playAni = function () {
        var _this = this;
        if (this.player) {
            this.player.clear();
        }
        this.player = new SVGA.Player('#svgBorder');
        var parser = new SVGA.Parser();
        parser.load(this.nobilityInfo.avatarFrameSvg, function (videoItem) {
            {
                _this.player.setVideoItem(videoItem);
                _this.player.startAnimation();
            }
        });
    };
    // 2022/5/11 18:12 清除动画
    View.prototype.clearAni = function () {
        if (this.player) {
            this.player.clear();
        }
    };
    // 2022/2/15 15:12 滑动的方法
    View.prototype.handleScroll = function () {
        var imgCWidth = window.screen.width; //屏幕宽度0
        // 330/299 = imgCWidth/topHeight  - Number(this.navH) - Number(70)
        var topHeight = Math.ceil(imgCWidth / (330 / 299)) - Number(this.navH) - Number(70); //适配屏幕大小
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        this.isShowNav = false;
        this.isFix = false;
        // 2022/2/15 16:33 顶部吸附功能
        if (Number(topHeight) - Number(scrollTop) <= 10) {
            this.isFix = true;
        }
        if (scrollTop <= 0) {
            this.isShowNav = true; //显示热门信用卡
        }
    };
    View.prototype.toBack = function () {
        if (Number(this.awlGlobalState.pageJump) <= 1) {
            this.globalCommit('setting_pageJump', 1);
            this.awlGlobalConfig.onBack();
            return false;
        }
        else {
            this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) - 1);
            this.$router.go(-1);
        }
    };
    // 2022/4/27 17:27 跳转到财富榜
    View.prototype.toFortuneList = function () {
        var param = {
            navH: this.awlGlobalState.urlInitParams.navH,
            statusH: this.awlGlobalState.urlInitParams.statusH,
            version: this.awlGlobalState.urlInitParams.version,
            token: this.awlGlobalState.urlInitParams.token,
        };
        this.$router.push({
            path: '/nav/fortuneList',
            query: param,
        });
    };
    View.prototype.unmounted = function () {
        this.clearAni();
    };
    View = __decorate([
        Options({
            components: { NavPanel: NavPanel },
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
